import React from 'react'
// import { Link } from "react-router-dom"

import {
    DescriptionWrapper,
    DescriptionH1,
    DescriptionP,
    // DescriptionScan,
    // Barcode,
    // DescriptionScanP,
    DescriptionSm,
    // DescriptionApp, DescriptionImg,
    WebWrap
} from "./Section1Elements";

import "./section1.css"
// import barcode from "../../../assets/images/barcode.svg";
import smG from "../../../assets/images/smG.svg";
// import appstore from "../../../assets/images/appstore.svg";
// import googleplay from "../../../assets/images/googleplay.svg";

const Section1 = () => {
    return (
        <DescriptionWrapper>
            <DescriptionH1>
                Now, there’s a better way to save contents & be <span className='description_underline'>productive</span> with them.<br />
                <span className="description_gradient">The best experience, yet.</span>
            </DescriptionH1>
            <DescriptionP>
                All your favorite content from all over the internet,
                in one place, beautifully saved & organized: Create pipes,
                use tags & many alternative ways to help you organize
                contents you want to read or visit later!
            </DescriptionP>
            {/* <DescriptionApp>
                <Link to="/">
                    <DescriptionImg src={appstore} alt="app store" />
                </Link>
                <Link to="/">
                    <DescriptionImg src={googleplay} alt=" google play" />
                </Link>
            </DescriptionApp> */}
            {/* I wrapped DescriptionScan & DescriptionSm together into 
                WebWrap sort how they display for mobile and web
            */}
            <WebWrap>
                {/* <DescriptionScan>
                    <DescriptionScanP>Scan to download <br /> beta app</DescriptionScanP>
                    <Barcode src={barcode} alt="barcode to download app" />
                </DescriptionScan> */}
                <div className='request_app'>
                    <p>Request Beta App</p>
                </div>
                <DescriptionSm src={smG} alt="MyPipe social media illustration" />
            </WebWrap>
        </DescriptionWrapper>
    )
}

export default Section1;
